import { Stack, Typography } from '@mui/material';

import { OrderStatusModel } from '@merchant-clients/order';

import { StatusIndicator } from '@frontend/components';
import { tCommon } from '@frontend/locales';
import { statusTypeMap } from '@frontend/utils';

import { statusVariantMap } from '../../order-list.component';

export interface FilterStatusProps {
  statuses: OrderStatusModel[];
}

export const FilterStatus = ({ statuses: statusFilter }: FilterStatusProps) => {
  return (
    <Stack direction="row" columnGap={1} alignItems="center">
      {statusFilter.length === statusTypeMap.size ? (
        <Typography variant="caption">
          {tCommon.actions.allStatuses()}
        </Typography>
      ) : (
        statusFilter.map((status) => (
          <Stack
            direction="row"
            columnGap={0.5}
            alignItems="center"
            key={status}
          >
            <StatusIndicator variant={statusVariantMap[status]} />
            <Typography variant="caption">
              {statusTypeMap.get(status)!()}
            </Typography>
          </Stack>
        ))
      )}
    </Stack>
  );
};
